export const handleAddressSelect = (address, geocodeByAddress, getLatLng) => {
  console.log(address,'QQ@@@@@@@@@@@')
  try{
    geocodeByAddress(address).then((results) => getLatLng(results[0]));

  }catch(e){
    console.log(e.message,'SSSSSSSSS')
  }
  // .then((latLng) => setProceed(true));
  //   .then(latLng => console.log('Success', latLng))
  //   .catch(error => console.error('Error', error));
};
